var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "stripe-card" }, [
    _c("h2", [_vm._v("Credit Card")]),
    _c("div", { ref: "card-container", attrs: { id: "card-container" } }),
    _vm.errorMessage
      ? _c("div", { staticClass: "error-messages" }, [
          _vm._v(_vm._s(_vm.errorMessage))
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }